const RedwoodCreditUnionTag = [
  "OpCon",
  "Symitar Capture",
  "Python",
  "Git",
  "Jira",
  "Teams",
  "Confluence",
];
const EchoStarTag = [
  "Python",
  "MSSQL",
  "Git",
  "ServiceNow",
  "GSuite",
  "Freshdesk",
  "Jira",
  "Confluence",
  "Automation",
  "Obsidian",
];
const MightyOakMedicalTags = [
  "Python",
  "AWS",
  "EC2",
  "S3",
  "Git",
  "win32com",
  "Flutter",
  "VBA",
  "Javascript",
  "HTML",
  "CSS",
  "Microsoft IIS",
  "Automation",
  "Quality",
  "Regulatory",
  "SOP",
  "ISO",
  "IEC",
  "IEEE",
  "SDLC",
  "SQA",
];
const AtlassianTags = [
  "Jira",
  "Confluence",
  "Jira Service Desk",
  "Help Desk Support",
  "SAML",
  "Asset Management",
  "Documentation",
  "Customer Service",
  "Jamf",
];
const RohnertParkTags = [
  "Documentation",
  "Customer Service",
  "Python",
  "Workstation Imaging",
  "Cisco IP Telephony/VoIP",
  "Cisco Meraki",
  "Asset Management",
  "Networking",
  "Spiceworks",
  "Active Directory",
];
const CSUMBTags = [
  "Avaya IP Telephony",
  "Networking",
  "Help Desk Support",
  "Asset Management",
  "Documentation",
  "Customer Service",
];
const ExperienceTagContainer = [
  RedwoodCreditUnionTag,
  EchoStarTag,
  MightyOakMedicalTags,
  AtlassianTags,
  RohnertParkTags,
  CSUMBTags,
];

export { ExperienceTagContainer };
